import React from 'react';

const BannerImage = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1200 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      {/* Sky Gradient Background */}
      <defs>
        <linearGradient id="skyGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#0f7fb8', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#87CEEB', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="roadGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#444444', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#222222', stopOpacity: 1 }} />
        </linearGradient>
      </defs>

      {/* Sky */}
      <rect width="1200" height="350" fill="url(#skyGradient)" />

      {/* Sun */}
      <circle cx="150" cy="80" r="50" fill="#FFD700" opacity="0.9" />

      {/* Clouds */}
      <ellipse cx="250" cy="100" rx="60" ry="30" fill="white" opacity="0.7" />
      <ellipse cx="320" cy="110" rx="70" ry="25" fill="white" opacity="0.6" />
      <ellipse cx="900" cy="120" rx="80" ry="35" fill="white" opacity="0.5" />

      {/* Road */}
      <rect y="350" width="1200" height="150" fill="url(#roadGradient)" />

      {/* Road Lines */}
      <g stroke="white" strokeWidth="3" strokeDasharray="30,30" opacity="0.5">
        <line x1="0" y1="425" x2="1200" y2="425" />
      </g>

      {/* Taxi 1 - Left Side */}
      <g transform="translate(200, 380)">
        {/* Body */}
        <rect x="0" y="20" width="80" height="40" rx="4" fill="#199675" />
        <path
          d="M 20 20 L 28 5 L 52 5 L 60 20"
          fill="#199675"
        />
        {/* Windows */}
        <rect x="8" y="12" width="12" height="8" rx="1" fill="#87CEEB" />
        <rect x="28" y="12" width="12" height="8" rx="1" fill="#87CEEB" />
        <rect x="48" y="12" width="12" height="8" rx="1" fill="#87CEEB" />
        {/* Wheels */}
        <circle cx="15" cy="62" r="6" fill="#333333" />
        <circle cx="65" cy="62" r="6" fill="#333333" />
        {/* Details */}
        <circle cx="15" cy="62" r="3" fill="#666666" />
        <circle cx="65" cy="62" r="3" fill="#666666" />
        {/* Headlights */}
        <circle cx="2" cy="35" r="3" fill="#FFD700" />
      </g>

      {/* Taxi 2 - Center Back */}
      <g transform="translate(500, 400)" opacity="0.7">
        <rect x="0" y="10" width="60" height="30" rx="3" fill="#199675" />
        <path d="M 15 10 L 21 2 L 39 2 L 45 10" fill="#199675" />
        <rect x="6" y="6" width="9" height="6" rx="1" fill="#87CEEB" />
        <rect x="21" y="6" width="9" height="6" rx="1" fill="#87CEEB" />
        <circle cx="12" cy="42" r="4" fill="#333333" />
        <circle cx="48" cy="42" r="4" fill="#333333" />
      </g>

      {/* Taxi 3 - Right Side */}
      <g transform="translate(900, 385)">
        <rect x="0" y="15" width="75" height="38" rx="4" fill="#199675" />
        <path
          d="M 18 15 L 25 3 L 50 3 L 57 15"
          fill="#199675"
        />
        <rect x="6" y="10" width="11" height="7" rx="1" fill="#87CEEB" />
        <rect x="24" y="10" width="11" height="7" rx="1" fill="#87CEEB" />
        <rect x="42" y="10" width="11" height="7" rx="1" fill="#87CEEB" />
        <circle cx="13" cy="55" r="5" fill="#333333" />
        <circle cx="62" cy="55" r="5" fill="#333333" />
        <circle cx="13" cy="55" r="2.5" fill="#666666" />
        <circle cx="62" cy="55" r="2.5" fill="#666666" />
        <circle cx="1" cy="28" r="2.5" fill="#FFD700" />
      </g>

      {/* Text Overlay - On Right Side */}
      <defs>
        <filter id="textShadow">
          <feDropShadow dx="2" dy="2" stdDeviation="3" floodOpacity="0.5" />
        </filter>
      </defs>
      
      <text
        x="800"
        y="200"
        fontSize="56"
        fontWeight="bold"
        fill="#199675"
        filter="url(#textShadow)"
      >
        24/7
      </text>
      
      <text
        x="800"
        y="260"
        fontSize="32"
        fill="white"
        fontWeight="600"
        filter="url(#textShadow)"
      >
        Taxi Service
      </text>
    </svg>
  );
};

export default BannerImage;
